/**
 * Created by Pankaj on 27-Sep-2019
 */
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {RomanEmpireGameConfig} from "../RomanEmpireGameConfig";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {IGoldenGenieData, IWalkingWildData, WalkingWild} from "./WalkingWild";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {ISymbolPositions} from "../winpresentation/geniefeature/GenieFeatureController";
import {WildMultiplierContainer} from "./WildMultiplierContainer";
import {GoldenGenieLabels} from "../enums/GoldenGenieLabels";
import {IScatterShakeConfig} from "../winpresentation/romanEmpireShakeEffect/RomanEmpireShakeEffect";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {RomanEmpireEvents} from "../events/RomanEmpireEvents";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FinalMultiplier} from "./FinalMultiplier";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SoundManager} from "../resource/sound/SoundManager";
import {RomanEmpireSoundConfig} from "../RomanEmpireSoundConfig";
import Timeline = gsap.Timeline;
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {RomanEmpireReelSymbol} from "../symbols/RomanEmpireReelSymbol";

export class WalkingWildView extends BaseView {
    private _layer: PIXI.Container;
    private _activeWalkers: WildMultiplierContainer[] = [];
    private _wildsToCollect: WildMultiplierContainer[] = [];
    public static WALKING_DURATION: number = 0.8;
    public static WALKING_Wild_DURATION: number = 2;
    private _finalMultiplier: FinalMultiplier;
    private _stopShake: boolean = false;
    private _finalMultiplierTl: TimelineLite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.WALKING_WILD.name);
    }

    protected initAnimations(): void {
        this._layer.addChild(this);
        this.x = GameConfig.instance.REEL_AREA_POS_X;
    }

    /**
     * Play moving wild animation and update wild multiplier on end.
     */
    public startPresentation(goldenGenieData: IGoldenGenieData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const normalMul: WildMultiplierContainer[] = [];
        const goldenGenieTl: TimelineLite = new TimelineLite();
        const movingWildTl: TimelineLite | TweenLite | any [] = [];
        tl.delay(0.2);
        const scatterOutTl = this.playLeftMostWildOutAnim(goldenGenieData);
        tl.add(scatterOutTl, 0);
        const timePos: number = scatterOutTl.getLabelTime(GoldenGenieLabels.FRAME_MOVE_START) != -1 ? scatterOutTl.getLabelTime(GoldenGenieLabels.FRAME_MOVE_START) : 0;
        const goldenGenieWild = this.getNextGoldenGenie(goldenGenieData.goldenGeniePosNext.reelId, goldenGenieData.goldenGeniePosNext.symbolId);
        this._activeWalkers.forEach((wildMultiplierContainer: WildMultiplierContainer) => {
            movingWildTl.push(wildMultiplierContainer.multiplierScaleOut());
            movingWildTl.push(TweenLite.fromTo(wildMultiplierContainer, WalkingWildView.WALKING_DURATION * 0.5, {x: wildMultiplierContainer.x}, {
                x: Helper.getSymbolPositions(wildMultiplierContainer.reelId - 1, wildMultiplierContainer.symbolId)[0] - GameConfig.instance.REEL_AREA_POS_X,
            }));

            if (goldenGenieWild?.reelId == wildMultiplierContainer.reelId && goldenGenieWild.symbolId == wildMultiplierContainer.symbolId) {
                goldenGenieTl.add(wildMultiplierContainer.playMultiplierTransformAnim(false));
                if(this._activeWalkers.length == 1 && this._wildsToCollect.length == 0){
                    goldenGenieTl.add(()=> SoundManager.playFSScatterMultiplierUpdate());
                }
            } else {
                normalMul.push(wildMultiplierContainer);
            }
            movingWildTl.push(() => {
                this.updateActiveWalker(wildMultiplierContainer);
            });

        });
        movingWildTl.length && tl.add(() => SoundManager.playFSScatterMoves(), timePos);
        tl.add(movingWildTl, timePos);
        tl.add(goldenGenieTl);
        //tl.add(TweenLite.to({}, 0.5, {})); //delay 0.5
        if (goldenGenieData.goldenGeniePosNext.reelId != -1) {
            tl.add([
                this.getExplodeAnim(Helper.getSymbolPositions(goldenGenieData.goldenGeniePosNext.reelId, goldenGenieData.goldenGeniePosNext.symbolId)),
                this.getMovingEnergyAnim(normalMul, Helper.getSymbolPositions(goldenGenieData.goldenGeniePosNext.reelId, goldenGenieData.goldenGeniePosNext.symbolId)),
            ]);
        }
        WalkingWildView.WALKING_Wild_DURATION = tl.totalDuration();
        return tl;
    }

    /**
     * To update wild multiplier value
     * @param wildMultiplierContainer
     * not in use. now changed function moved in wildMultiplier playMultiplierTransformAnim
     */
    private updateWildMultiplier(wildMultiplierContainer: WildMultiplierContainer) {
        wildMultiplierContainer.multiplierValue = wildMultiplierContainer.nextMultiplierValue;
    }

    /**
     * To update Wild multipliers reelId and remove a wild from activeWalker array if
     * moving wild at first reel.
     * @param wildMultiplierContainer
     */
    private updateActiveWalker(wildMultiplierContainer: WildMultiplierContainer) {
        wildMultiplierContainer.reelId--;
        if (wildMultiplierContainer.reelId == 0) {
            this._wildsToCollect.push(wildMultiplierContainer);
            this.removeActiveWalker(wildMultiplierContainer);
        }
    }

    /**
     * To remove wild from active wild array.
     * @param wildMultiplierContainer
     */
    private removeActiveWalker(wildMultiplierContainer: WildMultiplierContainer): void {
        const index = this._activeWalkers.indexOf(wildMultiplierContainer, 0);
        if (index > -1) {
            this._activeWalkers.splice(index, 1);
        }
    }

    /**
     * To create new walking wild and update multiplier value
     * @param walkingWilds
     */
    public createAndShowWalkingWilds(walkingWilds: Map<string, IWalkingWildData> | IWalkingWildData[]) {
        walkingWilds.forEach((walkingWildData: IWalkingWildData) => {
            if (walkingWildData.isNewWild) {
                walkingWildData.isNewWild = false;
                const walkingWildContainer = new WildMultiplierContainer(walkingWildData.reelId, walkingWildData.symbolId, walkingWildData.multiplier, walkingWildData.isHandOver);
                walkingWildContainer.isGoldenGenie = walkingWildData.isDefaultGoldenGenie;
                walkingWildContainer.nextMultiplierValue = walkingWildData.nextMultiplier;
                walkingWildContainer.nextReelId = walkingWildData.reelId - 1;
                this.addChild(walkingWildContainer);
                this.reArrangeWalkingWildMultiplier(walkingWildData.reelId, walkingWildData.symbolId);
                walkingWildData.reelId == 0 ? this._wildsToCollect.push(walkingWildContainer) : this._activeWalkers.push(walkingWildContainer);
            } else {
                let wildMultiplierContainer: WildMultiplierContainer | undefined = this.getActiveWalkerByReelAndSymbolId(walkingWildData.reelId, walkingWildData.symbolId);
                if (wildMultiplierContainer) {
                    wildMultiplierContainer.isHandOver = walkingWildData.isHandOver;
                    wildMultiplierContainer.nextMultiplierValue = walkingWildData.nextMultiplier;
                    wildMultiplierContainer.nextReelId = walkingWildData.reelId - 1;
                }
            }
        });
    }

    private reArrangeWalkingWildMultiplier(reelId: number, symbolId: number) {
        while (symbolId < 3 && symbolId > -1) {
            symbolId--;
            let wildMultiplierContainer: WildMultiplierContainer | undefined = this.getActiveWalkerByReelAndSymbolId(reelId, symbolId);
            wildMultiplierContainer?.parent && this.addChild(wildMultiplierContainer);
        }
    }

    private getActiveWalkerByReelAndSymbolId(reelId: number, symbolId: number): WildMultiplierContainer | undefined {
        for (let i = 0; i < this._activeWalkers.length; i++) {
            if (this._activeWalkers[i].reelId == reelId && this._activeWalkers[i].symbolId == symbolId) {
                return this._activeWalkers[i];
            }
        }
        return undefined;
    }

    private getNextGoldenGenie(nextReelId: number, symbolId: number): WildMultiplierContainer | undefined {
        const allWalker = this._activeWalkers.concat(this._wildsToCollect);
        for (let i = 0; i < allWalker.length; i++) {
            if (allWalker[i].nextReelId == nextReelId && allWalker[i].symbolId == symbolId && !allWalker[i].isOut) {
                return allWalker[i];
            }
        }
        return undefined;
    }

    public stopPresentation() {
        this.cleanUpWilds();
    }

    /**
     * To remove walking wilds.
     */
    private cleanUpWilds(): void {
        this._wildsToCollect.forEach((wildMultiplierContainer: WildMultiplierContainer) => {
            if (wildMultiplierContainer) {
                this.removeChild(wildMultiplierContainer);
            }
        });

        this._activeWalkers.forEach((wildMultiplierContainer: WildMultiplierContainer) => {
            if (wildMultiplierContainer) {
                this.removeChild(wildMultiplierContainer);
            }
        });
        this._activeWalkers = [];
        this._wildsToCollect = [];
    }

    protected onResize(resizeData: IResizeData): void {
        this.x = GameConfig.instance.REEL_AREA_POS_X;
    }

    private getGoldenFrame(sourceWildMultiplier: WildMultiplierContainer): TimelineSprite {
        //const goldenFrame: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("genieHandOverFrame")[0]);

        const pos: number[] = Helper.getSymbolPositions(sourceWildMultiplier.reelId, sourceWildMultiplier.symbolId);
        const goldenFrame: TimelineSprite = this.createSprite("genieHandOverFrame", pos, undefined, undefined, true);
        //goldenFrame.anchor.set(0.5);
        //this.addChild(goldenFrame);
        this.addChildAt(goldenFrame, 0);
        goldenFrame.hide();
        return goldenFrame;
    }


    private scatterShakeEffect(config: IScatterShakeConfig): TimelineMax {
        let startPosY: number = 0;
        let startPosX: number = config.obj.x;
        let t: boolean = true;
        const tl: TimelineMax = new TimelineMax({
            onStart: () => {
                startPosY = config.obj.y;
                startPosX = config.obj.x;
            },
            onComplete: () => {
                if (this._stopShake) {
                    return;
                    config.obj.angle = 0;

                }
                config.obj.angle = 0;
                config.obj.x = startPosX;
                // if (config.positionCb) {
                //     config.obj.x = config.positionCb().x;
                //     config.obj.y = config.positionCb().y;
                // }
            },
            onUpdate: () => {
                if (this._stopShake) {
                    return;
                    config.obj.angle = 0;

                }
                config.obj.angle = 0;
                const nt: number = tl.progress();
                const lt: number = tl.time();
                let et: number = config.ease ? config.ease.getRatio(nt) as number : nt;
                if (t) {
                    t = false;
                    return;
                }
                // if (config.positionCb) {
                //     startPosX = config.positionCb().x;
                //     startPosY = config.positionCb().y;
                // }
                if (config.reverseEase)
                    et = 1 - et;
                if (config.Intensity) {
                    if (config.angle != 0)
                        config.obj.angle = (Math.cos(lt * config.hertz) * et) * config.angle;
                }
            }
        });
        !this._stopShake && tl.to(this, config.duration, {});
        return tl;
    }

    /**
     * Moving wild disappear animation on first reel.
     */
    public playLeftMostWildOutAnim(goldenGenieData: IGoldenGenieData): TimelineLite {
        const tl: TimelineLite = new TimelineLite({paused: true});
        let endAnimations: WildMultiplierContainer[] = [];
        if (goldenGenieData.goldenGeniePosNext.reelId != -1) {
            const wildsTl: TimelineLite[] = [];
            const totalWilds: number = this._wildsToCollect.length;
            this._wildsToCollect.forEach((wildMultiplierContainer: WildMultiplierContainer, index) => {
                endAnimations.push(wildMultiplierContainer);
                tl.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_GOLDEN_GENIE_HANDOVER_START));
                    WalkingWild.IS_HANDOVER = true;
                });
                const posArr = this.getHandOverMultiplierPos(totalWilds, 30);
                const handoverTl = this.playGoldenGenieHandOverAnim(wildMultiplierContainer, goldenGenieData.goldenGeniePosNext, posArr, index);
                wildsTl.push(handoverTl);
            });
            if (wildsTl.length) {
                const goldenFrameMoveStartTime: number = wildsTl[0].getLabelTime(GoldenGenieLabels.FRAME_MOVE_START);
                tl.add([
                    wildsTl,
                    () => SoundManager.playSound(RomanEmpireSoundConfig.instance.FS_SCATTER_EXPLODE),
                ], 0);
                tl.add(() => SoundManager.playFSScatterToScatter(), goldenFrameMoveStartTime);
                tl.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_GOLDEN_GENIE_HANDOVER_END));
                    WalkingWild.IS_HANDOVER = false;
                });
                tl.addLabel(GoldenGenieLabels.FRAME_MOVE_START, goldenFrameMoveStartTime);
                tl.add(()=> SoundManager.playFSScatterExplodeMultiplier(), wildsTl[0].getLabelTime(GoldenGenieLabels.GOLDEN_GENIE_EXPLODE_MULTIPLIER));
            }
        } else {
            this._wildsToCollect.forEach((wildMultiplierContainer: WildMultiplierContainer, index) => {
                endAnimations.push(wildMultiplierContainer);
                tl.add([
                    wildMultiplierContainer.multiplierScaleOut(0.00001, 0),
                    !wildMultiplierContainer.isOut && wildMultiplierContainer.playOutAnimation(true),
                ], 0);
                if (index == 0) {
                    tl.add(() => {
                        EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_FINAL_MULTIPLIER_MOVE_START));
                        WalkingWild.IS_FINAL_MULTIPLIER_MOVING = true;
                        this.createFinalMultiplier(goldenGenieData.goldenGenieMultiplierNextSpin, wildMultiplierContainer);
                    }, WalkingWildView.WALKING_DURATION * 0.4);
                }
                tl.add(TweenLite.to({}, 0.2, {}))
            });
        }

        if (endAnimations.length > 0) {
            tl.add(() => {
                endAnimations.forEach((wildMultiplierContainer: WildMultiplierContainer) => {
                    this.removeChild(wildMultiplierContainer);
                    this._wildsToCollect.splice(this._wildsToCollect.indexOf(wildMultiplierContainer), 1);
                });
            });
        }
        tl.play(0);
        return tl;
    }

    private createFinalMultiplier(value: number, sourceWildMultiplierContainer: WildMultiplierContainer) {
        if (!this._finalMultiplier || !this._finalMultiplier.isActive) {
            this._finalMultiplier = new FinalMultiplier(value, [sourceWildMultiplierContainer.x, sourceWildMultiplierContainer.y]);
            this.addChild(this._finalMultiplier);
            this._finalMultiplier.sourceSymId = sourceWildMultiplierContainer.symbolId;
        }
        this._finalMultiplier.multiplier = value;
        this._finalMultiplier.show();
    }

    private resetFinalMultiplier(): TimelineLite {
        const tl: TimelineLite = new TimelineMax();
        tl.add(this._finalMultiplier?.hide());
        tl.add(() => {
            EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.ON_FINAL_MULTIPLIER_MOVE_END));
            WalkingWild.IS_FINAL_MULTIPLIER_MOVING = false;
            this.removeChild(this._finalMultiplier);
        });
        return tl;
    }

    public finalMultiplierOnFeatureTriggered(goldenGenieData?: IWalkingWildData) {
        this.resetFinalMultiplier();
    }

    public onBounce(reelDelayArr: number[], reelStoppedData: IReelStoppedData, genieFeatureM3Pos: ISymbolPositions, goldenGenieData?: IWalkingWildData, isGenieReel: boolean = false) {
        if (this._finalMultiplier?.isActive) {
            if (this._finalMultiplierTl?.isActive()) {
                this._finalMultiplierTl.pause().kill();
            }
            this._finalMultiplierTl = new TimelineLite();
            const topY: number = Helper.getSymbolPositions(0, 0)[1];
            const bottomY: number = Helper.getSymbolPositions(0, 2)[1];
            const reelId = reelStoppedData.reelId;
            let delay: number = reelId < 4 ? reelDelayArr[reelId + 1] - reelDelayArr[reelId] : reelDelayArr[reelId];
            //genieFeatureM3Pos it will be always -1 now
            if (genieFeatureM3Pos.reelId != -1 && genieFeatureM3Pos.reelId == reelStoppedData.reelId && goldenGenieData) {
                this._finalMultiplier.isActive = false;
                const pos: number[] = Helper.getSymbolPositions(goldenGenieData.reelId, goldenGenieData.symbolId);
                this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.1, {x: pos[0], y: pos[1]}));
                return;
            }
            if (isGenieReel && goldenGenieData && genieFeatureM3Pos.reelId == -1) {
                const goldenGenieSym = Reels.getSymbol(goldenGenieData.reelId, goldenGenieData.symbolId);
                if(goldenGenieSym && (goldenGenieSym.symName == "M2" || goldenGenieSym.symName == "M3")){
                    //handle special case for final multiplier for M2 and M3
                    this._finalMultiplier.isActive = false;
                    const pos: number[] = Helper.getSymbolPositions(goldenGenieData.reelId, goldenGenieData.symbolId);
                    this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.1, {x: pos[0], y: pos[1]}));
                    return;
                }
                delay = reelId == 4 ? 2 : delay; // to fix #271
                this._finalMultiplier.isActive = false;
                this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.1, {y: Helper.getSymbolPositions(goldenGenieData.reelId, goldenGenieData.symbolId)[1]}));
                this._finalMultiplierTl.add(() => {
                    this.createAndShowWalkingWilds([goldenGenieData]);
                    this.resetFinalMultiplier();
                });
                return;
            }
            if (reelId < 4) {
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier.scale, delay * 0.04, {x: 0, y: 0}));
                this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.1, {
                    x: Helper.getSymbolPositions(reelId + 1, 0)[0],
                    y: bottomY
                }));
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier.scale, delay * 0.04, {x: 1, y: 1}));
                this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.9, {y: topY}));
            } else {
                this._finalMultiplierTl.add(this.resetFinalMultiplier())
            }
        }
    }

    public playFinalMultiplierAnimOverReel(reelDelayArr: number[]) {
        if (this._finalMultiplier && this._finalMultiplier.isActive) {
            if (this._finalMultiplierTl?.isActive()) {
                this._finalMultiplierTl.pause().kill();
            }
            this._finalMultiplierTl = new TimelineLite();
            const topY: number = Helper.getSymbolPositions(0, 0)[1];
            this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, 0.4, {y: topY}));
            if (this._finalMultiplier.sourceSymId == 0) {
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.4, {y: bottomSymPos[1]}));
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.5, {y: topSymPos[1]}));
            } else if (this._finalMultiplier.sourceSymId == 1) {
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.3, {y: bottomSymPos[1]}));
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.4, {y: topSymPos[1]}));
            } else {
                //this._finalMultiplierTl.add(TweenLite.to(this._finalMultiplier, delay * 0.4, {y: topSymPos[1]}));
            }
        }
    }

    private playBlastAnim(wildMultiplierContainer: WildMultiplierContainer): Timeline {
        const blast: TimelineSprite = wildMultiplierContainer.createSprite("goldenBlast", [wildMultiplierContainer.x, wildMultiplierContainer.y], 27, true);
        this.addChild(blast);
        //blast.blendMode = PIXI.BLEND_MODES.ADD;
        return blast.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(blast);
        });
    }

    private createHandOverMultiplier(wildMultiplierContainer: WildMultiplierContainer) {
        let multiplierText: PIXI.BitmapText = wildMultiplierContainer.createBitmapText("x" + wildMultiplierContainer.multiplierValue, [wildMultiplierContainer.x, wildMultiplierContainer.y + 60], "center");
        multiplierText.anchor = 0.5;
        multiplierText.alpha = 0;
        multiplierText.pivot.y = multiplierText.height * 0.3;
        return multiplierText;
    }

    private getHandOverMultiplierPos(totalWilds: number, radius: number): PIXI.Point[] {
        const posArr: PIXI.Point[] = [];
        const angleInRad: number = (360 / ++totalWilds) * (Math.PI / 180);
        for (let i = 1; i < totalWilds + 1; i++) {
            // +1 added in angle to avoid multiplier in horizontal line
            const point = new PIXI.Point(Math.round(radius * Math.cos(angleInRad * i + 1)), Math.round(radius * Math.sin(angleInRad * i +1)));
            posArr.push(point);
        }
        return posArr;
    }

    public playMultiplierHandOverAnim(multiplier: PIXI.BitmapText, mulDestPos: PIXI.Point): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add([
            TweenLite.to(multiplier.scale, WalkingWildView.WALKING_DURATION * 0.3, {
                x: 1.2, y: 1.2, onComplete: () => {
                    TweenLite.to(multiplier.scale, WalkingWildView.WALKING_DURATION * 0.2, {x: 0.6, y: 0.6});
                }
            }),
            TweenLite.to(multiplier, WalkingWildView.WALKING_DURATION * 0.5, {x: mulDestPos.x, y: mulDestPos.y}),
        ], 0);
        return tl;
    }

    private playGoldenGenieHandOverAnim(sourceWildMultiplier: WildMultiplierContainer, goldenGeniePosNext: ISymbolPositions, posArr: PIXI.Point[], index: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._stopShake = false;

        const pos: number[] = Helper.getSymbolPositions(goldenGeniePosNext.reelId, goldenGeniePosNext.symbolId);
        const goldenFrame: TimelineSprite = this.getGoldenFrame(sourceWildMultiplier);
        const goldenGenieWild = this.getNextGoldenGenie(goldenGeniePosNext.reelId, goldenGeniePosNext.symbolId);
        if (goldenGenieWild) {
            const multiplierDestPos: PIXI.Point = new PIXI.Point(pos[0] + goldenGenieWild.text.x, pos[1] + goldenGenieWild.text.y);
            const multiplierDestScatteredPos: PIXI.Point = new PIXI.Point(multiplierDestPos.x + posArr[index + 1].x, multiplierDestPos.y + posArr[index + 1].y);
            const handOverMultiplier: PIXI.BitmapText = this.createHandOverMultiplier(sourceWildMultiplier);
            // playshake on scatter.
            tl.add(() => {
                TweenLite.to(sourceWildMultiplier.scale, 0.5, {x: 0.8, y: 0.8})
            }, 0);
            tl.add(() => {
                this.scatterShakeEffect({
                    angle: 6,
                    obj: sourceWildMultiplier as any,
                    duration: 1,
                    Intensity: 4,
                    hertz: 155,
                    // positionCb: () => new PIXI.Point((Reels.getSymbol(1, 1) as StateReelSymbol).position.x, (Reels.getSymbol(1, 1) as StateReelSymbol).position.y),
                }).play();
            }, 0);
            tl.add(() => {
                TweenLite.to(sourceWildMultiplier.scale, 0.5, {x: 1, y: 1})
            }, 0.5);

            tl.add(this.playBlastAnim(sourceWildMultiplier), 0.4);

            tl.add([
                () => this.addChild(handOverMultiplier),
                TweenLite.to(handOverMultiplier, 0.001, {alpha: 1}),
                sourceWildMultiplier.multiplierScaleOut(0.001, 0)
            ], 0.9); //1s

            tl.add(() => sourceWildMultiplier.transformToNormal(), 0.6);

            tl.add([
                GoldenGenieLabels.FRAME_MOVE_START,
                () => sourceWildMultiplier.playOutAnimation(false),
            ], 1.4);
            sourceWildMultiplier.isGoldenGenie && tl.add([
                () => {
                    goldenFrame.playLoop();
                    goldenFrame.show();
                },
                TweenLite.to(goldenFrame, WalkingWildView.WALKING_DURATION * 0.5, {x: pos[0], y: pos[1]}), //0.5s
            ], 1.4);
            tl.add(() => {
                this._stopShake = true
            });
            tl.add(() => goldenGenieWild?.playGoldenBlurAnim());

            tl.add([
                //GoldenGenieLabels.MULTIPLIER_HANDOVER_START,
                goldenGenieWild && this.playMultiplierHandOverAnim(handOverMultiplier, multiplierDestScatteredPos),
                () => {
                    goldenGenieWild.playMultiplierHandOverAnim(posArr[0]);
                },
            ], 1.52);
            tl.add(() => this.removeChild(goldenFrame));

            if (goldenGenieWild && !goldenGenieWild.isGoldenGenie) {
                tl.add([
                    goldenGenieWild?.playPuffsAnim(true),
                    () => SoundManager.playFSScatterFire(),
                    goldenGenieWild?.playParticlesAnim(),
                    goldenGenieWild.transformToGoldenGenie()
                ]);
            }

            tl.add(this.playMultiplierOutAnim(handOverMultiplier, goldenGenieWild, multiplierDestPos), 3.5); //3.0 + 0.5
            tl.add([
                () => goldenGenieWild.playBlastAnim(true),
                GoldenGenieLabels.GOLDEN_GENIE_EXPLODE_MULTIPLIER,
            ]);
        }

        return tl;
    }

    private playMultiplierOutAnim(handOverMultiplier: PIXI.BitmapText, goldenGenieWild: WildMultiplierContainer, multiplierDestPos: PIXI.Point): TweenLite[] {
        return [
            TweenLite.to(handOverMultiplier, 0.2, {
                x: multiplierDestPos.x, y: multiplierDestPos.y, onComplete: () => {
                    handOverMultiplier.parent.removeChild(handOverMultiplier);
                }
            }),
            TweenLite.to(handOverMultiplier.scale, 0.05, {
                x: 0.7, y: 0.7, onComplete: () => {
                    TweenLite.to(handOverMultiplier.scale, 0.15, {x: 0, y: 0})
                }
            }),
            TweenLite.to(goldenGenieWild.text.scale, 0.2, {x: 0, y: 0}),
            TweenLite.to(goldenGenieWild.text, 0.2, {x: 0, y: 60})];
    }

    /**
     * To get blast animation
     * @param pos : position
     */
    private getExplodeAnim(pos: number[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const genieFeatureRays: TimelineSprite = this.createSprite("genieFeatureRays", pos, 30, undefined, true);
        //TODO double copy if required
        genieFeatureRays.hide();
        genieFeatureRays.scale.set(0);
        const mask: PIXI.Graphics = new PIXI.Graphics();
        mask.clear();
        mask.beginFill();
        mask.drawRect(RomanEmpireGameConfig.instance.REEL_AREA_POS_X, RomanEmpireGameConfig.instance.REEL_AREA_POS_Y, RomanEmpireGameConfig.instance.REEL_AREA_WIDTH, RomanEmpireGameConfig.instance.REEL_AREA_HEIGHT);
        mask.endFill();

        const spine: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("smokeBlast"));
        const spineCopy: PIXI.spine.Spine = new PIXI.spine.Spine(GameResources.getSpineAsset("smokeBlast"));
        spine.position.set(pos[0], pos[1]);
        spineCopy.position.set(pos[0], pos[1]);
        spine.alpha = 0;
        spineCopy.alpha = 0;
        spine.mask = mask;
        spineCopy.mask = mask;
        spine.tint = 0xFAA501;
        spineCopy.tint = 0xFAA501;
        //spine.tint = 0xFBB000;
        //spine.spineData.slots.forEach()

        this.addChild(spine, spineCopy, mask);
        tl.add(() => {
            spine.alpha = 1;
            spineCopy.alpha = 0.5;
        });

        tl.add([
            new SpineTween(spine, 0, "smoke_blast_animation"),
            new SpineTween(spineCopy, 0, "smoke_blast_animation"),
            () => {
                spine.state.setAnimation(0, "smoke_blast_animation", false).timeScale = 0.8;
                spineCopy.state.setAnimation(0, "smoke_blast_animation", false).timeScale = 0.8;
            },
            genieFeatureRays.getAnimationAutoShowHide(true, false, undefined, undefined, () => {
                TweenLite.to(genieFeatureRays, 0.3, {alpha: 0});
            }),
            TweenLite.to(genieFeatureRays.scale, 0.2, {x: 2, y: 2}),
            TweenLite.to(spine.scale, 0.7, {x: 1.2, y: 1.2}),
            TweenLite.to(spineCopy.scale, 0.2, {x: 1.3, y: 1.3})
        ]);

        tl.add(() => {
            this.removeChild(spine, spineCopy, mask);
        });
        return tl;
    }


    private createSprite(texture: string, position?: ISymbolPositions | number[], sourceFPS?: number, parent?: PIXI.Container, isJPEG: boolean = false): TimelineSprite {
        const textures: PIXI.Texture [] = GameResources.getTextures(texture);
        const sprite: TimelineSprite = new TimelineSprite(textures, sourceFPS);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            position = position instanceof Array ? position : Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(position[0], position[1]);
        }
        isJPEG && (sprite.blendMode = PIXI.BLEND_MODES.ADD);
        parent && parent.addChild(sprite);
        return sprite;
    }

    private getMovingEnergyAnim(wildMultiplierContainerArr: WildMultiplierContainer[], currPos: number[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        currPos[1] += 60;
        wildMultiplierContainerArr.forEach((wildMultiplierContainer, index) => {
            const destPos: number[] = Helper.getSymbolPositions(wildMultiplierContainer.nextReelId, wildMultiplierContainer.symbolId);
            destPos[1] += 60;
            tl.add([
                this.playEnergyAnim(currPos, destPos),
                GoldenGenieLabels.GOLDEN_GENIE_SHOOT_FIRE_BALL,
            ], 0.1);
            tl.add([
                () => wildMultiplierContainer.playMultiplierTransformAnim(true),
                GoldenGenieLabels.GOLDEN_GENIE_MULTIPLIER_UPDATE
            ]);
            //currPos = destPos;
        });
        if(wildMultiplierContainerArr.length){
            tl.add(()=> SoundManager.playFSScatterShootFireBall(),tl.getLabelTime(GoldenGenieLabels.GOLDEN_GENIE_SHOOT_FIRE_BALL));
            tl.add(()=> SoundManager.playFSScatterMultiplierUpdate(),tl.getLabelTime(GoldenGenieLabels.GOLDEN_GENIE_MULTIPLIER_UPDATE) + 0.15);
        }
        return tl;
    }

    private getDistance(p1: PIXI.Point, p2: PIXI.Point) {
        const xDist = p2.x - p1.x;
        const yDist = p2.y - p1.y;
        return Math.sqrt(Math.pow(xDist, 2) + Math.pow(yDist, 2));
    }

    private getMidPoint(p1: PIXI.Point, p2: PIXI.Point) {
        return new PIXI.Point((p1.x + p2.x) * 0.5, (p1.y + p2.y) * 0.5);
    }

    private getAngleInDegree(pos1: number[], pos2: number[]): number {
        let angle = Math.atan2(pos1[0] - pos2[0], pos1[1] - pos2[1]);
        angle = angle < 0 ? (2 * Math.PI + angle) : angle;
        const finalAngle = angle * (180 / Math.PI);
        return 360 - 90 - finalAngle; //pixi object use clockwise angle.
    }

    private playEnergyAnim(pos1: number[], pos2: number[]): TimelineLite {
        const movingEnergy: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("movingEnergy")[0]);
        this.addChild(movingEnergy);
        movingEnergy.blendMode = PIXI.BLEND_MODES.ADD;
        movingEnergy.position.set(pos1[0], pos1[1]);
        movingEnergy.alpha = 0;
        const distance = this.getDistance(new PIXI.Point(pos1[0], pos1[1]), new PIXI.Point(pos2[0], pos2[1]));
        const scale = distance / movingEnergy.width;
        movingEnergy.anchor.set(0.2, 0.5);
        movingEnergy.scale.set(0.3, 1);
        movingEnergy.angle = this.getAngleInDegree(pos1, pos2);
        const tl = new TimelineLite();
        tl.add([
                TweenLite.to(movingEnergy, 0.001, {alpha: 1}),
                TweenLite.to(movingEnergy.scale, 0.2, {x: scale * 1.6, y: 0.8,}),
            ]
        );
        tl.add([
            TweenLite.to(movingEnergy.scale, 0.15, {x: 0.3, y: 0.5}),
            TweenLite.to(movingEnergy, 0.15, {x: pos2[0], y: pos2[1]}),
            TweenLite.to(movingEnergy.anchor, 0.2, {x: 0.5})
        ]);
        tl.add(() => {
            TweenLite.to(movingEnergy, 0.001, {alpha: 0}),
                this.removeChild(movingEnergy);
        });
        return tl;
    }

    public resetLayer() {
        this._layer.position.set(0, 0);
    }
}
